module.exports = __webpack_public_path__ + "img/Reiss Nelson.87c19e9a.png";